import useUserSession from "../useUserSession/useUserSession";

interface Access {
  canAccessContent: (category: string, subcategory: string) => boolean;
  canAccessAction: (category: string, subcategory: string, action: string) => boolean;
  canAdminAccessAction: (category: string, subcategory: string, action: string) => boolean;
}

const useAccess = (): Access => {
  const [getSession] = useUserSession();
  const { permissions } = getSession();

  /* Method to validate the action accesses like sidebar menus */
  const canAccessContent = (category: string, subcategory: string): boolean => {
    if (category === "public" || subcategory === "public") {
      return true;
    }
    const actions =
      permissions?.find(
        (item) =>
          item?.category?.toLowerCase()?.trim() === category?.toLowerCase()?.trim() &&
          item?.sub_category?.toLowerCase()?.trim() === subcategory?.toLowerCase()?.trim(),
      )?.actions || [];
    return actions?.some((action) => action?.toLowerCase()?.trim() === "view");
  };

  /* Method to validate the action accesses like create, update, delete, */
  const canAccessAction = (
    category: string,
    subcategory: string,
    allowedAction: string,
  ): boolean => {
    if (category === "public" || subcategory === "public") {
      return true;
    }
    const actions =
      permissions?.find(
        (item) =>
          item?.category?.toLowerCase()?.trim() === category?.toLowerCase()?.trim() &&
          item?.sub_category?.toLowerCase()?.trim() === subcategory?.toLowerCase()?.trim(),
      )?.actions || [];
    return actions?.some(
      (allowedActions) =>
        allowedActions?.toLowerCase()?.trim() === allowedAction?.toLowerCase()?.trim(),
    );
  };
  //to validate admin have access to the action like create, update, delete, etc.
  const canAdminAccessAction = (
    category: string,
    subcategory: string,
    allowedAction: string,
  ): boolean => {
    if (category === "public" || subcategory === "public") {
      return true;
    }
    const adminRolesAccess = JSON.parse(localStorage.getItem("adminRolesAccess") || "[]");
    if (adminRolesAccess?.length > 0) {
      const actions =
        adminRolesAccess?.find(
          (item) =>
            item?.category?.toLowerCase()?.trim() === category?.toLowerCase()?.trim() &&
            item?.sub_category?.toLowerCase()?.trim() === subcategory?.toLowerCase()?.trim(),
        )?.actions || [];
      return actions?.some(
        (allowedActions) =>
          allowedActions?.name?.toLowerCase()?.trim() === allowedAction?.toLowerCase()?.trim(),
      );
    }
    return false;
  };

  return { canAccessContent, canAccessAction, canAdminAccessAction };
};

export default useAccess;
